// Simple Mobile Modal Navigation Enhancement for Dawn Theme
// This enhances the existing modal without breaking the structure

document.addEventListener('DOMContentLoaded', function() {
  console.log('Modal script loaded');
  const modal = document.querySelector('product-modal');
  if (!modal) {
    console.log('No product-modal found');
    return;
  }
  
  let currentMediaIndex = 0;
  let mediaElements = [];
  let isTouch = false;
  let startX = 0;
  let startY = 0;
  let currentX = 0;
  
  function initModal() {
    console.log('Init modal called');
    console.log('Screen width:', window.innerWidth);
    
    // CRITICAL: Check if we're on mobile FIRST - if not, do NOTHING
    const isMobileDevice = window.innerWidth <= 749;
    console.log('Is mobile device:', isMobileDevice);
    
    if (!isMobileDevice) {
      console.log('DESKTOP MODE: Doing absolutely nothing, keeping original Dawn behavior');
      return; // EXIT EARLY - no mobile code runs on desktop
    }
    
    // Check if mobile navigation already exists (prevent duplicate initialization)
    const existingNav = modal.querySelector('.mobile-modal-nav');
    if (existingNav) {
      console.log('Mobile navigation already exists, skipping initialization');
      return;
    }
    
    console.log('MOBILE MODE: Setting up mobile navigation');
    
    // Debug: Let's see what's actually in the modal
    const modalContent = modal.querySelector('.product-media-modal__content');
    console.log('Modal content:', modalContent);
    
    // Try different selectors to find media
    const allImages = modal.querySelectorAll('img');
    const allVideos = modal.querySelectorAll('video');
    const allMedia = modal.querySelectorAll('[data-media-type]');
    
    console.log('Found images:', allImages.length);
    console.log('Found videos:', allVideos.length);
    console.log('Found media elements:', allMedia.length);
    
    // For mobile, set up navigation
    mediaElements = Array.from(allImages);
    
    if (mediaElements.length <= 1) {
      console.log('Only one or no media elements found, skipping mobile navigation');
      return;
    }
    
    console.log('Adding mobile navigation for', mediaElements.length, 'media elements');
    
    // We're definitely on mobile at this point, so set up mobile behavior
    console.log('Mobile: Setting up single image display...');
    mediaElements.forEach((media, index) => {
      const mediaContainer = media.closest('.global-media-settings');
      console.log(`Mobile - Image ${index}:`, media, 'Container:', mediaContainer);
      
      if (index === 0) {
        media.style.display = 'block';
        media.style.visibility = 'visible';
        if (mediaContainer) {
          mediaContainer.style.display = 'block';
          mediaContainer.style.visibility = 'visible';
        }
        console.log(`Mobile - Showing image ${index}`);
      } else {
        media.style.display = 'none';
        if (mediaContainer) {
          mediaContainer.style.display = 'none';
        }
        console.log(`Mobile - Hiding image ${index}`);
      }
    });
    
    // Add mobile navigation (we know we're on mobile)
    if (modalContent) {
      console.log('Adding mobile navigation - touch events and buttons');
      addTouchEvents(modalContent);
      addNavigationButtons(modalContent);
      updateDots(); // Initialize dots
    }
  }
  
  function addTouchEvents(element) {
    // Add touch-action CSS to prevent scrolling during swipes
    element.style.touchAction = 'manipulation';
    // Also apply to the modal content specifically
    const modalContent = element.querySelector('.product-media-modal__content') || element;
    modalContent.style.touchAction = 'manipulation';
    modalContent.style.userSelect = 'none';
    
    element.addEventListener('touchstart', handleTouchStart, { passive: true });
    element.addEventListener('touchmove', handleTouchMove, { passive: false });
    // element.addEventListener('touchend', handleTouchEnd, { passive: true });
  }
  
  function handleTouchStart(e) {
    isTouch = true;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    currentX = startX;
  }
  
  function handleTouchMove(e) {
    if (!isTouch) return;
    
    currentX = e.touches[0].clientX;
    const diffX = Math.abs(currentX - startX);
    const currentY = e.touches[0].clientY;
    const diffY = Math.abs(currentY - startY);
    
    // Prevent scrolling more aggressively during potential swipes
    if (diffX > 10 || diffY < diffX) {
      e.preventDefault();
      e.stopPropagation();
    }
  }
  
  function handleTouchEnd(e) {
    if (!isTouch) return;
    isTouch = false;
    
    const diffX = currentX - startX;
    const threshold = 50; // Minimum swipe distance
    
    if (Math.abs(diffX) > threshold) {
      if (diffX > 0) {
        // Swipe right - previous image
        if (currentMediaIndex > 0) {
          showMediaWithAnimation(currentMediaIndex - 1);
        }
      } else {
        // Swipe left - next image  
        if (currentMediaIndex < mediaElements.length - 1) {
          showMediaWithAnimation(currentMediaIndex + 1);
        }
      }
    }
  }
  
  function addNavigationButtons(container) {
    const buttonsHTML = `
      <style>
        /* Mobile navigation styles - only applied when navigation exists */
        .mobile-modal-nav {
          display: block !important;
        }
        .modal-dots-indicator {
          display: flex !important;
        }
        .swipe-hint {
          display: block !important;
        }
        /* Prevent scrolling during modal interaction on mobile only */
        .product-media-modal__content {
          touch-action: manipulation !important;
          user-select: none !important;
          -webkit-user-select: none !important;
          -webkit-touch-callout: none !important;
          overflow: hidden !important;
        }
      </style>
      <div class="mobile-modal-nav" style="
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        transform: translateY(-50%);
        pointer-events: none;
        z-index: 10;
      ">
        <button class="mobile-modal-nav__btn mobile-modal-nav__btn--prev" style="
          position: absolute;
          left: 1rem;
          background: transparent;
          color: white;
          border: none;
          border-radius: 50%;
          width: 48px;
          height: 48px;
          display: flex;
          align-items: center;
          justify-content: center;
          pointer-events: all;
          cursor: pointer;
          transition: all 0.2s ease;
          // backdrop-filter: blur(10px);
          // box-shadow: 0 4px 15px rgba(0,0,0,0.4);
          z-index: 1000;
        ">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" style="transition: transform 0.2s ease; filter: drop-shadow(0 2px 4px rgba(0,0,0,0.5));">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button class="mobile-modal-nav__btn mobile-modal-nav__btn--next" style="
          position: absolute;
          right: 1rem;
          background: transparent;
          color: white;
          border: none;
          border-radius: 50%;
          width: 48px;
          height: 48px;
          display: flex;
          align-items: center;
          justify-content: center;
          pointer-events: all;
          cursor: pointer;
          transition: all 0.2s ease;
          // backdrop-filter: blur(10px);
          // box-shadow: 0 4px 15px rgba(0,0,0,0.4);
          z-index: 1000;
        ">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" style="transition: transform 0.2s ease; filter: drop-shadow(0 2px 4px rgba(0,0,0,0.5));">
            <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      
      <!-- Page Dots Indicator -->
      <div class="modal-dots-indicator" style="
        position: absolute;
        bottom: 2rem;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        gap: 8px;
        pointer-events: none;
        z-index: 10;
      ">
        ${Array.from({length: mediaElements.length}, (_, i) => `
          <div class="modal-dot" data-index="${i}" style="
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: ${i === 0 ? 'rgba(255,255,255,0.9)' : 'rgba(255,255,255,0.3)'};
            transition: all 0.3s ease;
            cursor: pointer;
            pointer-events: all;
          "></div>
        `).join('')}
      </div>
      
      
    `;
    
    container.insertAdjacentHTML('beforeend', buttonsHTML);
    console.log('Mobile navigation HTML added to container');
    
    // Add event listeners to buttons
    const prevBtn = container.querySelector('.mobile-modal-nav__btn--prev');
    const nextBtn = container.querySelector('.mobile-modal-nav__btn--next');
    
    console.log('Navigation buttons found:', { prevBtn: !!prevBtn, nextBtn: !!nextBtn });
    
    // Button animations and interactions
    [prevBtn, nextBtn].forEach(btn => {
      // Hover/touch effects
      btn.addEventListener('mousedown', () => {
        btn.style.transform = 'scale(0.9)';
        btn.style.background = 'transparent';
      });
      
      btn.addEventListener('mouseup', () => {
        btn.style.transform = 'scale(1)';
        btn.style.background = 'transparent';
      });
      
      btn.addEventListener('mouseleave', () => {
        btn.style.transform = 'scale(1)';
        btn.style.background = 'transparent';
        btn.querySelector('svg').style.transform = 'scale(1)';
      });
      
      btn.addEventListener('mouseenter', () => {
        btn.style.background = 'transparent';
        btn.style.transform = 'scale(1.05)';
        btn.querySelector('svg').style.transform = 'scale(1.1)';
      });
    });
    
    prevBtn.addEventListener('mousedown', goToPrevious);
    nextBtn.addEventListener('mousedown', goToNext);
    
    // Add event listeners to dots
    const dots = container.querySelectorAll('.modal-dot');
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => showMediaWithAnimation(index));
    });
    
    // Show swipe hint briefly
    const swipeHint = container.querySelector('.swipe-hint');
    setTimeout(() => {
      swipeHint.style.opacity = '1';
      setTimeout(() => {
        swipeHint.style.opacity = '0';
      }, 2500);
    }, 500);
    
    updateButtonVisibility();
  }
  
  function goToPrevious() {
    console.log("prev");
    if (currentMediaIndex > 0) {
      showMediaWithAnimation(currentMediaIndex - 1);
    }
  }
  
  function goToNext() {
    console.log("next");
    if (currentMediaIndex < mediaElements.length - 1) {
      showMediaWithAnimation(currentMediaIndex + 1);
    }
  }
  
  function showMediaWithAnimation(index) {
    if (index < 0 || index >= mediaElements.length || index === currentMediaIndex) return;
    
    console.log('Animating to media index:', index, 'from', currentMediaIndex);
    
    const currentMedia = mediaElements[currentMediaIndex];
    const currentContainer = currentMedia?.closest('.global-media-settings');
    const newMedia = mediaElements[index];
    const newContainer = newMedia?.closest('.global-media-settings');
    
    if (!newMedia || !currentMedia) return;
    
    // Add transition styles to both containers
    [currentContainer, newContainer].forEach(container => {
      if (container) {
        container.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
      }
    });
    
    // Fade out current image
    if (currentContainer) {
      currentContainer.style.opacity = '0';
      currentContainer.style.transform = 'scale(0.95)';
    }
    
    // After fade out, switch images
    setTimeout(() => {
      // Hide current
      currentMedia.style.display = 'none';
      if (currentContainer) {
        currentContainer.style.display = 'none';
        currentContainer.style.opacity = '1';
        currentContainer.style.transform = 'scale(1)';
      }
      
      // Show new with fade in effect
      currentMediaIndex = index;
      newMedia.style.display = 'block';
      newMedia.style.visibility = 'visible';
      if (newContainer) {
        newContainer.style.display = 'block';
        newContainer.style.visibility = 'visible';
        newContainer.style.opacity = '0';
        newContainer.style.transform = 'scale(1.05)';
        
        // Force reflow then animate in
        newContainer.offsetHeight;
        newContainer.style.opacity = '1';
        newContainer.style.transform = 'scale(1)';
      }
      
      updateButtonVisibility();
      updateDots();
      
      // Clean up transitions after animation
      setTimeout(() => {
        [currentContainer, newContainer].forEach(container => {
          if (container) {
            container.style.transition = '';
          }
        });
      }, 300);
      
    }, 150);
  }
  
  function showMedia(index) {
    if (index < 0 || index >= mediaElements.length) return;
    
    console.log('Showing media index:', index, 'from', currentMediaIndex);
    
    // Hide current media
    if (mediaElements[currentMediaIndex]) {
      const currentMedia = mediaElements[currentMediaIndex];
      const currentContainer = currentMedia.closest('.global-media-settings');
      currentMedia.style.display = 'none';
      if (currentContainer) currentContainer.style.display = 'none';
      console.log('Hid media:', currentMediaIndex);
    }
    
    // Show new media
    currentMediaIndex = index;
    const newMedia = mediaElements[currentMediaIndex];
    const newContainer = newMedia.closest('.global-media-settings');
    newMedia.style.display = 'block';
    newMedia.style.visibility = 'visible';
    if (newContainer) {
      newContainer.style.display = 'block';
      newContainer.style.visibility = 'visible';
    }
    console.log('Showed media:', currentMediaIndex);
    
    updateButtonVisibility();
  }
  
  function updateButtonVisibility() {
    const prevBtn = modal.querySelector('.mobile-modal-nav__btn--prev');
    const nextBtn = modal.querySelector('.mobile-modal-nav__btn--next');
    
    if (prevBtn) {
      prevBtn.style.opacity = currentMediaIndex === 0 ? '0.3' : '1';
      prevBtn.disabled = currentMediaIndex === 0;
      prevBtn.style.pointerEvents = currentMediaIndex === 0 ? 'none' : 'all';
    }
    
    if (nextBtn) {
      nextBtn.style.opacity = currentMediaIndex === mediaElements.length - 1 ? '0.3' : '1';
      nextBtn.disabled = currentMediaIndex === mediaElements.length - 1;
      nextBtn.style.pointerEvents = currentMediaIndex === mediaElements.length - 1 ? 'none' : 'all';
    }
  }
  
  function updateDots() {
    const dots = modal.querySelectorAll('.modal-dot');
    dots.forEach((dot, index) => {
      if (index === currentMediaIndex) {
        dot.style.background = 'rgba(255,255,255,0.9)';
        dot.style.transform = 'scale(1.2)';
        dot.style.boxShadow = '0 0 10px rgba(255,255,255,0.5)';
      } else {
        dot.style.background = 'rgba(255,255,255,0.3)';
        dot.style.transform = 'scale(1)';
        dot.style.boxShadow = 'none';
      }
    });
  }
  
  // Listen for modal open events
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
        if (modal.hasAttribute('open')) {
          setTimeout(initModal, 100); // initModal will check if mobile and exit early if desktop
        }
      }
    });
  });
  
  observer.observe(modal, { attributes: true });
  
  // Also listen for thumbnail clicks to sync the starting image (only works if mobile navigation exists)
  document.addEventListener('click', function(e) {
    const thumbnail = e.target.closest('[data-target]');
    if (thumbnail && modal.hasAttribute('open')) {
      // Only handle this if we have mobile navigation (meaning we're on mobile)
      const hasNavigation = modal.querySelector('.mobile-modal-nav__btn--prev');
      if (!hasNavigation) return; // Exit if no mobile navigation exists (desktop)
      
      const mediaId = thumbnail.dataset.target?.split('-').pop();
      const targetIndex = mediaElements.findIndex(media => 
        media.id && media.id.includes(mediaId)
      );
      
      if (targetIndex >= 0) {
        setTimeout(() => showMediaWithAnimation(targetIndex), 150);
      }
    }
  });
  
  // Handle window resize to ensure proper behavior switching (with debounce)
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (modal.hasAttribute('open')) {
        const isNowMobile = window.innerWidth <= 749;
        const hasNavigation = modal.querySelector('.mobile-modal-nav');
        const wasMobile = !!hasNavigation;
        
        console.log('Window resized. Width:', window.innerWidth, 'Is mobile:', isNowMobile, 'Was mobile:', wasMobile);
        
        // If we switched categories, clean up and reinitialize
        if (wasMobile && !isNowMobile) {
          console.log('Switched from mobile to desktop - cleaning up mobile elements');
          cleanupMobileElements();
        } else if (!wasMobile && isNowMobile) {
          console.log('Switched from desktop to mobile - reinitializing');
          setTimeout(initModal, 50);
        }
      }
    }, 100); // Debounce resize events
  });
  
  function cleanupMobileElements() {
    // Remove mobile navigation
    const mobileNav = modal.querySelector('.mobile-modal-nav');
    if (mobileNav) {
      mobileNav.remove();
      console.log('Mobile navigation removed');
    }
    
    // Remove dots indicator
    const dotsIndicator = modal.querySelector('.modal-dots-indicator');
    if (dotsIndicator) {
      dotsIndicator.remove();
      console.log('Dots indicator removed');
    }
    
    // Remove swipe hint
    const swipeHint = modal.querySelector('.swipe-hint');
    if (swipeHint) {
      swipeHint.remove();
      console.log('Swipe hint removed');
    }
    
    // Remove injected styles
    const injectedStyles = modal.querySelectorAll('style');
    injectedStyles.forEach(style => {
      if (style.textContent.includes('mobile-modal-nav')) {
        style.remove();
        console.log('Mobile styles removed');
      }
    });
    
    // Reset all images to be visible (desktop behavior)
    const allImages = modal.querySelectorAll('img');
    allImages.forEach((media, index) => {
      media.style.display = 'block';
      media.style.visibility = 'visible';
      const mediaContainer = media.closest('.global-media-settings');
      if (mediaContainer) {
        mediaContainer.style.display = 'block';
        mediaContainer.style.visibility = 'visible';
      }
      console.log(`Desktop - Image ${index} restored to visible`);
    });
    
    // Remove touch action restrictions
    const modalContent = modal.querySelector('.product-media-modal__content');
    if (modalContent) {
      modalContent.style.touchAction = '';
      modalContent.style.userSelect = '';
      modalContent.style.webkitUserSelect = '';
      modalContent.style.webkitTouchCallout = '';
      modalContent.style.overflow = '';
      console.log('Modal content styles reset');
    }
    
    // Clear media elements array
    mediaElements = [];
    currentMediaIndex = 0;
    console.log('Mobile state cleared');
  }
});

// Keyboard navigation support (only works when mobile navigation is present)
document.addEventListener('keydown', function(e) {
  const activeModal = document.querySelector('product-modal[open]');
  if (!activeModal) return;
  
  // Only handle keyboard navigation if mobile navigation buttons exist (mobile mode)
  const prevBtn = activeModal.querySelector('.mobile-modal-nav__btn--prev');
  const nextBtn = activeModal.querySelector('.mobile-modal-nav__btn--next');
  
  // Only proceed if mobile navigation is present (meaning we're in mobile mode)
  if (!prevBtn || !nextBtn) {
    // On desktop, don't interfere with default behavior
    return;
  }
  
  if (e.key === 'ArrowLeft' || e.key === 'Left') {
    e.preventDefault();
    if (!prevBtn.disabled) {
      prevBtn.click();
    }
  } else if (e.key === 'ArrowRight' || e.key === 'Right') {
    e.preventDefault();
    if (!nextBtn.disabled) {
      nextBtn.click();
    }
  }
});
